import React, { useMemo } from 'react'
import { MarkerF } from '@react-google-maps/api'
import BaiduMarker from '@/component/map/baidu/BaiduMarker'
import { useMapType } from '@/component/map/MapContext'
import { wgs84ToBd09 } from '@/util/coordTransform'

export interface UnifiedMarkerProps {
    position: { lat: number; lng: number }
    icon?: {
        url: string
        scaledSize?: { width: number; height: number }
    }
    title?: string
    opacity?: number
    animation?: 'BOUNCE' | 'DROP' | null
    onClick?: () => void
}

const UnifiedMarker: React.FC<UnifiedMarkerProps> = ({
    position,
    icon,
    title,
    opacity,
    animation,
    onClick
}) => {
    const { mapType } = useMapType()

    // Google Maps: plain object -> google.maps.Size 변환
    const googleIcon = useMemo(() => {
        if (mapType !== 'google' || !icon) return undefined

        return {
            url: icon.url,
            scaledSize: icon.scaledSize
                ? new google.maps.Size(icon.scaledSize.width, icon.scaledSize.height)
                : undefined,
        }
    }, [mapType, icon])

    if (mapType === 'baidu') {
        const [bdLat, bdLng] = wgs84ToBd09(position.lat, position.lng)

        return (
            <BaiduMarker
                position={{ lat: bdLat, lng: bdLng }}
                icon={icon ? { url: icon.url, scaledSize: icon.scaledSize } : undefined}
                title={title}
                opacity={opacity}
                animation={animation}
                onClick={onClick}
            />
        )
    }

    const googleAnimation = animation === 'BOUNCE'
        ? google.maps.Animation.BOUNCE
        : animation === 'DROP'
            ? google.maps.Animation.DROP
            : undefined

    return (
        <MarkerF
            position={position}
            icon={googleIcon}
            title={title}
            opacity={opacity}
            animation={googleAnimation}
            onClick={onClick}
        />
    )
}

export default UnifiedMarker
